<template> 
  <div class="row">
    <div class="col-lg-12 col-sm-12" >
        <input type="text" value="" id="v-step-0" placeholder="Search...">
        <div class="v-step-1">A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'.</div>
        <div data-v-step="2">A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'.</div>

        
        <v-tour name="myTour" :steps="steps">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-if="tour.currentStep === index"
                v-for="(step, index) of tour.steps"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :isFirst="tour.isFirst"
                :isLast="tour.isLast"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions">
                    <div @click="tour.stop" class="btn-fechar-help">x</div>
                    <button @click="tour.nextStep" class="btn btn-primary">Próximo</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 1">
                  <div slot="actions">
                    <div @click="tour.stop" class="btn-fechar-help">x</div>
                    <button @click="tour.previousStep" class="btn btn-primary">Passo Anterior</button>
                    <button @click="tour.nextStep" class="btn btn-primary">Próximo</button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 2">
                  <div slot="actions">
                    <div @click="tour.stop" class="btn-fechar-help">x</div>
                    <button @click="tour.previousStep" class="btn btn-primary">Passo Anterior</button>
                    <button @click="tour.nextStep" class="btn btn-primary">Próximo</button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
      </v-tour>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'my-tour',
    data () {
      return {
        steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: `Discover Vue Tour!`
          },
          {
            target: '.v-step-1',
            content: 'An awesome plugin made with Vue.js!'
          },
          {
            target: '[data-v-step="2"]',
            content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.'
          }
        ]
      }
    },
    methods: {
      nextStep () {
        this.$tours['myTour'].nextStep()
      },
      showLastStep () {
        this.$tours['myTour'].currentStep = this.steps.length - 1
      },
      myCustomPreviousStepCallback (currentStep) {
        console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1))
      },
      myCustomNextStepCallback (currentStep) {
        console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1))

        if (currentStep === 1) {
          console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3')
        }
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Tour.vue